module.exports = __webpack_public_path__ + "static/media/cat.a09cf8eb.png";